import {Injectable} from '@angular/core';
import {DataCoreService, DlistDto} from '@dabnet-kamu/libs/ui';
import {BehaviorSubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class TebKurumSinifService {
  public period!: number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();
  private baseEntity1: string | undefined;

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {
  }


  setParams(period: number, isReadOnly: boolean, isBindCheck: boolean) {
    this.period = period;
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  getData(
    code: string,
    control: any,
    period: number,
    baseEntity?: string,
    isSetData?: boolean,
    modul?: string,
    tur: string = 'Y'   // default Y
  ) {
    let dataSource: any;
    let tableName = "";
    const filterArr: any[] = [];

    if (this.isBindCheck && this.isReadOnly) {
      // sadece gösterim için
      tableName = control.showEntity
        ? control.showEntity
        : control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
      dataSource.select(["Kod", "Ad", "KurumsalKod", "Donem"]);
    } else {
      this.baseEntity1 = baseEntity;
      let tableName = this.baseEntity1;
      const queryParams: string[] = [];

      // Modul varsa ekle
      if (modul?.length > 0) {
        queryParams.push(`Modul=${modul}`);
      }

      // Tur parametresi (default Y)
      if (tur?.length > 0) {
        queryParams.push(`Tur=${tur}`);
      }

      // Donem parametresi
      if (period) {
        queryParams.push(`Donem=${period}`);
      }

      // Query stringi birleştir
      if (queryParams.length > 0) {
        tableName = `${tableName}?${queryParams.join("&")}`;
      }

      dataSource = this.dataCoreService.getOData(tableName);
      dataSource.select(["Kod", "Ad", "KurumsalKod", "Donem"]);
    }

    // Filtreler
    if (code) {
      filterArr.push(["KurumsalKod", "startswith", code]);
    }
    filterArr.push(["KurumsalKod.Length", ">=", 8]);
    dataSource.filter(filterArr);

    return dataSource;
  }

}
